module.exports = __webpack_public_path__ + "static/media/career-evaluation.fc4ed270.png";